import React from 'react';
import Scroll from 'react-scroll';

class Textinput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {focused: false}
        this.preventDot = false;
    }

    focusHandler() {
        this.setState({focused: true});
    }
    blurHandler() {
        this.setState({focused: false});
    }

    _onChange(e) {
        let { inputProcessing, onChange, type } = this.props,
        value = e.target.value,
        forbiddenSymbols = ['x','c','v','r','!','@','#','$','%','^','&','*','(',')','_','-','=','|','\\','?','>','<','{','}','[',']','§','\"','№',';',':','/',',','`','±','~',"'"]

        const isIncludes = (str, arr) => {
            return arr.some( s => str.indexOf(s) != -1 );
        }

        switch(inputProcessing) {
            case 'decimalTwoDigits':
                e.target.value = e.target.value.toString().split('.').map((el,i)=>i?el.split('').slice(0,2).join(''):el).join('.');
                break;
            case 'integer':
                e.target.value = e.target.value ? parseInt(e.target.value) : '';
                break;
        }

        //Do not display symbols if type is number
        if ( !(type=='number' && isIncludes(value, forbiddenSymbols) ) ) {
            onChange(e);
        }
    }

    _onKeyDown(e) {
        let deniedCharCodes = [189];
        for (let i=65; i<=90; i++) {
            if (i!=67 && i!=82 && i!=86 && i!=88) {
                deniedCharCodes.push(i);
            }
        }
        const isNumberKey = e => {
            var maxLength = this.props.maxLength || 20;
            var value = e.target.value;
            var charCode = (e.which) ? e.which : e.keyCode;
            if (e.target.value.indexOf('.') == -1) this.preventDot = false;

            if ( deniedCharCodes.some( _ => _ == charCode ) || (charCode == 190 && this.preventDot) ) {
                e.preventDefault();
            } else {
                if (charCode == 190) this.preventDot = true;
            }
            if (value.length >= maxLength) e.target.value = value.substr(0, maxLength-1);
        }

        const isStringKey = e => {
            const value = e.target.value;
            const model = this.props.model;
            const fieldName = this.props.name;
            let maxLength = this.props.maxLength || 50;
            if (model == 'company' && fieldName == 'name') {
                maxLength = 100;
            }
            if (fieldName == 'address' || fieldName == 'description') {
                maxLength = 254;
            }
            if (fieldName == 'whatsapp' ||
                fieldName == 'skype' ||
                fieldName == 'post_code') {
                maxLength = 25;
            }

            if (value.length >= maxLength) e.target.value = value.substr(0, maxLength-1);
        }

        return this.props.type=='number' ? isNumberKey(e) : isStringKey(e);
    }

	render() {
        let { type, invalid, required, onChange, label, value, name, readOnly, autoComplete, max, min, buttonPadding, scrollName, showLabel = true } = this.props;
        let newValue = (!value || value == null || typeof value === 'undefined') ? '' : value;
        let labelClass = (this.state.focused ? 'highlight ' : '') + (newValue ? 'active' : '');

		return (
            <div className={`field-wrap ${invalid ? 'error' : ''}`}>
                <Scroll.Element name={scrollName || name} />
                {showLabel ? (
                    <label className={labelClass}>
                        {label} {required && <span className="req">*</span>}
                    </label>
                ) : null}
                <input
                    onFocus={this.focusHandler.bind(this)}
                    onBlur={this.blurHandler.bind(this)}
                    onChange={this._onChange.bind(this)}
                    onKeyDown={this._onKeyDown.bind(this)}
                    value={newValue}
                    name={name}
                    className={buttonPadding ? 'with-padding' : ''}
                    autoComplete={autoComplete}
                    readOnly={readOnly}
                    type={type != 'number' ? type : 'text'}
                    required={required}
                />
            </div>
        );
	}
}

Textinput.defaultProps = {
    autoComplete: 'off',
    type: 'text',
}


export default Textinput;



// WEBPACK FOOTER //
// ./source/components/textinput.js